import React, { useState, useEffect } from "react";
import LandingNav from "./Landing_Nav";
import LandingFooter from "./Landing_Footer";
import { Helmet } from "react-helmet";

const Cancellation = ({ onSignUpClick, onLoginClick }) => {


  return (
    <>
 

      <div className=" landing-body-bg">
        <LandingNav onSignUpClick={onSignUpClick} onLoginClick={onLoginClick} />
        <div className="padding-5-rem " style={{ height: "100vh" }}>
          <div className="row">
            <div className="col-12">
              <div className=" border-radius-20 pb-5 ">
                <div className="text-2-2  py-4 pb-5 ">
                  Return/ Refund/ Cancellation Policy
                </div>
                <div className="">
                  <p>
                    We only offer digital products, so refunds, cancellations,
                    or returns are not possible after an order has been placed.
                    If you have a continuing subscription, you can cancel
                    anytime, and no charges will be deducted after you cancel
                    the subscription or membership.
                  </p>
                  <p>Nonetheless, no fees subtracted prior to the termination of membership can be reimbursed.
                  </p>
                  <p className="text-3-2">
                  For any additional inquiries about cancellations or refunds, kindly reach out to us via email at
                  {" "} <a
                      href="https://mail.google.com/mail/?view=cm&fs=1&to=support@anlook.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                     
                      support@anlook.com
                    </a>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <LandingFooter />
      </div>
    </>
  );
};
export default Cancellation;
